import { StandardEvents } from '@shopify/events';
import { formatMoney } from '@theme/money-formatting';

let generation = 0;

function render(cart) {
  for (const link of document.querySelectorAll('[data-rg3-header] .rg3h-cart')) {
    const price = link.querySelector('span');
    const count = link.querySelector('b');
    if (price) price.innerHTML = formatMoney(cart.total_price, document.querySelector('[data-rg3-cart-sync]').dataset.moneyFormat, cart.currency || document.querySelector('[data-rg3-cart-sync]').dataset.currency);
    if (count) count.textContent = String(cart.item_count);
    link.setAttribute('aria-label', `Varukorg, ${cart.item_count} artiklar`);
  }
}

async function refresh() {
  const current = ++generation;
  try {
    const response = await fetch(window.Shopify.routes.root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) return;
    const cart = await response.json();
    if (current === generation) render(cart);
  } catch (error) {
    if (error.name !== 'AbortError') console.warn('[rg3-header-cart]', error);
  }
}

document.addEventListener(StandardEvents.cartLinesUpdate, async (event) => {
  try {
    const result = await event.promise;
    if (result?.detail?.didError) return;
    await refresh();
  } catch (error) {
    if (error.name !== 'AbortError') console.warn('[rg3-header-cart]', error);
  }
});

window.addEventListener('pageshow', refresh);
document.addEventListener('shopify:section:load', refresh);
refresh();
